import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from 'firebase/auth';

import { auth } from '../firebase-config';

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  const [user, setUser] = useState({});
  const [selectedStore, setSelectedStore] = useState();
  const [loading, setLoading] = useState(true);

  function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function signUp(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }
  function logOut() {
    return signOut(auth);
  }
  function finishSignIn(result, resolve, reject) {
    const email = result?.user?.email;
    if (!email) {
      logOut();
      setLoading(false);
      reject(new Error('Invalid user.'));
      return;
    }
    authenticateEmail(email)
      .then((accepted) => {
        if (accepted) {
          resolve(result);
        } else {
          logOut();
          reject(new Error('Invalid user.'));
        }
      })
      .finally(() => setLoading(false));
  }

  function googleSignIn() {
    setLoading(true);
    const googleAuthProvider = new GoogleAuthProvider();
    return new Promise((resolve, reject) => {
      signInWithPopup(auth, googleAuthProvider)
        .then((result) => finishSignIn(result, resolve, reject))
        .catch((error) => { setLoading(false); reject(error); });
    });
  }

  function microsoftSignIn() {
    setLoading(true);
    const microsoftProvider = new OAuthProvider('microsoft.com');
    const tenant = process.env.REACT_APP_AZURE_TENANT_ID;
    if (tenant) microsoftProvider.setCustomParameters({ tenant });
    return new Promise((resolve, reject) => {
      signInWithPopup(auth, microsoftProvider)
        .then((result) => finishSignIn(result, resolve, reject))
        .catch((error) => { setLoading(false); reject(error); });
    });
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentuser) => {
      setUser(currentuser);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const authenticateEmail = async (email) => {
    try {
      const response = await axios.get(`/hd-api/user/check/${email}`, {
        'Content-Type': 'application/json',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching users from db:', error);
      return false;
    }
  };
  return (
    <userAuthContext.Provider
      value={{
        user,
        logIn,
        signUp,
        logOut,
        googleSignIn,
        microsoftSignIn,
        loading,
        selectedStore,
        setSelectedStore,
      }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}
